import { useEffect, useState, useCallback } from "react";
import { Download } from "lucide-react";
import api from "@/lib/api";

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);

  const load = useCallback(() => api.get("/admin/newsletter").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const exportCsv = () => {
    const rows = ["email,subscribed_at", ...items.map((i) => `${i.email},${i.created_at}`)].join("\n");
    const blob = new Blob([rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-newsletter">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-serif text-4xl text-espresso">Newsletter</h1>
          <p className="text-espresso/60 mt-2">{items.length} subscribers</p>
        </div>
        {items.length > 0 && (
          <button onClick={exportCsv} data-testid="newsletter-export" className="inline-flex items-center gap-2 bg-espresso text-ivory rounded-full px-5 py-2.5 text-sm font-medium hover:bg-forest transition-colors">
            <Download size={16} /> Export CSV
          </button>
        )}
      </div>

      <div className="mt-8 bg-taupe rounded-2xl p-6">
        {items.length === 0 ? <p className="text-espresso/50">No subscribers yet.</p> : (
          <div className="divide-y divide-champagne/30">
            {items.map((i) => (
              <div key={i.id} className="flex items-center justify-between py-3" data-testid={`subscriber-${i.id}`}>
                <span className="text-espresso">{i.email}</span>
                <span className="text-espresso/50 text-sm">{new Date(i.created_at).toLocaleDateString()}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
